import React from "react";
import { useState, useEffect } from "react";
import {
  fetchCardInfo,
  fetchSegmentationData,
  fetchWatchersTimeData,
} from "../../../services/cardDataFunctions";
import CamAudienciaMiniCard from "../miniCards/CamAudienciaMiniCard";
// import CamChartMiniCard from "../miniCards/CamChartMiniCard"; POR AHORA NO SE USA
import LineDashedCard from "../../charts/lineChart/LineDashedChart";
import GraficaSegmentacionNegativeChart from "../../charts/barWithNegatives/GraficaSegmentacionNegativeChart";

import CircularProgress from "@mui/material/CircularProgress";
import LeftCam from "../../../assets/LeftCam.svg";
import CenterCam from "../../../assets/CenterCam.svg";
import RightCam from "../../../assets/RightCam.svg";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ConversionIcon from "../../../assets/conversion.svg";
import WatchLaterOutlinedIcon from "@mui/icons-material/WatchLaterOutlined";
import HourglassBottomOutlinedIcon from "@mui/icons-material/HourglassBottomOutlined";
import CamSingleBarChartMiniCard from "../miniCards/CamSingleBarChartMiniCard";
import CamSingleBarChartLargeCard from "../miniCards/CamSingleBarChartLargeCard";

const SectionCard = (props) => {
  const { cameraObj, position } = props;
  // estados para las graficas de segmentacion
  const [cardInfoObj, setCardInfoObj] = useState({});
  // estados para las graficas de segmentacion
  const [segmentationObj, setSegmentationObj] = useState({});
  // estados para las graficas de observadores vs tiempo
  const [watchersTimeObj, setWatchersTimeObj] = useState({});
  // estado para el loader
  const [cardInfoLoader, setCardInfoLoader] = useState(false);
  const [segmentationLoader, setSegmentationLoader] = useState(false);
  const [watchersTimeLoader, setWatchersTimeLoader] = useState(false);

  // useEffect para obtener los datos de las cards de cada camara
  useEffect(() => {
    const controller = new AbortController();
    const loadCardInfoData = async () => {
      if (
        !cameraObj.store_id ||
        cameraObj.age_ranges.length === 0 ||
        !cameraObj.start_date ||
        !cameraObj.end_date
      )
        return;
      setCardInfoLoader(true);
      try {
        fetchCardInfo(cameraObj, controller.signal).then((data) => {
          setCardInfoObj(data);
        });
      } catch (error) {
        console.error(
          "Error al obtener los datos de las graficas de segmentacion",
          error
        );
        if (error.name !== "AbortError") {
          console.error("Error fetching segmentation graphic", error);
        }
      } finally {
        setCardInfoLoader(false);
      }
    };
    loadCardInfoData();
    return () => controller.abort();
  }, [cameraObj]);

  // useEffect para obtener los datos de las graficas de segmentacion
  useEffect(() => {
    const controller = new AbortController();
    const loadSegmentationGraphic = async () => {
      if (
        !cameraObj.store_id ||
        cameraObj.age_ranges.length === 0 ||
        !cameraObj.start_date ||
        !cameraObj.end_date
      )
        return;
      setSegmentationLoader(true);
      try {
        fetchSegmentationData(cameraObj, controller.signal).then((data) => {
          setSegmentationObj(data);
        });
      } catch (error) {
        console.error(
          "Error al obtener los datos de las graficas de segmentacion",
          error
        );
        if (error.name !== "AbortError") {
          console.error("Error fetching segmentation graphic", error);
        }
      } finally {
        setSegmentationLoader(false);
      }
    };
    loadSegmentationGraphic();
    return () => controller.abort();
  }, [cameraObj]);

  // useEffect para obtener los datos de las graficas de Observadores vs tiempo
  useEffect(() => {
    const controller = new AbortController();
    const loadWatchersTimeGraphic = async () => {
      if (
        !cameraObj.store_id ||
        cameraObj.age_ranges.length === 0 ||
        !cameraObj.start_date ||
        !cameraObj.end_date
      )
        return;
      setWatchersTimeLoader(true);
      try {
        fetchWatchersTimeData(cameraObj, controller.signal).then((data) => {
          setWatchersTimeObj(data);
        });
      } catch (error) {
        console.error(
          "Error al obtener los datos de las graficas de segmentacion",
          error
        );
        if (error.name !== "AbortError") {
          console.error("Error fetching segmentation graphic", error);
        }
      } finally {
        setWatchersTimeLoader(false);
      }
    };
    loadWatchersTimeGraphic();
    return () => controller.abort();
  }, [cameraObj]);

  return (
    <div className="bg-gray-100 rounded-xl">
      {/* info y camaras */}
      <div className="flex flex-row items-center justify-between px-4 pt-2 pb-0">
        <div className="flex flex-col items-center justify-center space-x-2 xl:flex-row">
          <h3 className="text-sm font-bold xl:text-lg font-Roboto">
            Dispositivo:
          </h3>
          <h2 className="text-sm font-semibold xl:text-base font-Roboto">
            {cameraObj.camera_name}
          </h2>
        </div>
        {/* camaras */}
        <div className="flex items-center justify-center xl:space-x-2">
          <p className="text-sm font-bold text-center xl:text-lg font-Roboto">
            Ubicación:
          </p>
          <div className="w-[48px] h-[48px] object-contain">
            <img
              src={
                position === "left"
                  ? LeftCam
                  : position === "center"
                  ? CenterCam
                  : RightCam
              }
              className="w-full h-full"
              alt="svg"
            />
          </div>
        </div>
      </div>

      {/* cuadricula */}
      <div className="grid grid-cols-6 grid-rows-2 gap-4 p-4">
        <div className="col-start-1 col-span-2 row-start-1 row-span-1">
          {/* cuadro audiencia */}
          <CamAudienciaMiniCard
            data={cardInfoObj.audiencia_total || 0}
            cardLoader={cardInfoLoader}
          />
        </div>
        <div className="col-start-3 col-span-2 row-start-1 row-span-1">
          {/* observadores */}
          <CamSingleBarChartMiniCard
            cardInfoLoader={cardInfoLoader}
            data={{
              man: cardInfoObj.observadores_man || 0,
              woman: cardInfoObj.observadores_women || 0,
              total: cardInfoObj.observadores_total || 0,
            }}
            title={"Observadores"}
            suffix={""}
            Icon={VisibilityIcon}
          />
        </div>
        <div className="col-start-5 col-span-2 row-start-1 row-span-1">
          {/* conversion */}
          <CamSingleBarChartMiniCard
            cardInfoLoader={cardInfoLoader}
            data={{
              man: cardInfoObj.conversion_rate_man || 0,
              woman: cardInfoObj.conversion_rate_woman || 0,
              total: cardInfoObj.conversion_rate_total || 0,
            }}
            title={"Conversión"}
            suffix={"%"}
            Icon={ConversionIcon}
          />
        </div>
        <div className="col-start-1 col-span-3 row-start-2 row-span-1">
          {/* tiempo atención */}
          <CamSingleBarChartLargeCard
            cardInfoLoader={cardInfoLoader}
            data={{
              man: cardInfoObj.observadores_man_attention_time || 0,
              woman: cardInfoObj.observadores_woman_attention_time || 0,
              total: cardInfoObj.observadores_total_attention_time || 0,
            }}
            title={"Tiempo de atención"}
            suffix={" s."}
            Icon={WatchLaterOutlinedIcon}
          />
        </div>
        <div className="col-start-4 col-span-3 row-start-2 row-span-1">
          {/* Tiempo de estadía */}
          <CamSingleBarChartLargeCard
            cardInfoLoader={cardInfoLoader}
            data={{
              man: cardInfoObj.observadores_man_dwell_time || 0,
              woman: cardInfoObj.observadores_woman_dwell_time || 0,
              total: cardInfoObj.observadores_total_dwell_time || 0,
            }}
            title={"Tiempo de estadía"}
            suffix={" s."}
            Icon={HourglassBottomOutlinedIcon}
          />
        </div>
      </div>
      {/* grafica1 */}
      <div className="p-4">
        {segmentationLoader ? (
          <CircularProgress color="secondary" />
        ) : cameraObj &&
          Object.keys(cameraObj).length > 0 &&
          (cameraObj.age_ranges.length > 1 ||
            cameraObj.age_range_name === "Todos") ? (
          <GraficaSegmentacionNegativeChart
            segmentationData={segmentationObj}
          />
        ) : null}
      </div>
      {/* grafica2 */}
      <div className="p-4">
        {watchersTimeLoader ? (
          <CircularProgress color="secondary" />
        ) : (
          <LineDashedCard watchersTimeData={watchersTimeObj} />
        )}
      </div>
    </div>
  );
};

export default SectionCard;
